module.exports = __webpack_public_path__ + "img/hr-red-croton-06.0be6f4da.png";